
















































  import { Component, Watch, mixins, Prop } from 'nuxt-property-decorator'
  import { Account } from '@one/types'
  import cloneDeep from 'lodash/cloneDeep'
  import AgreementsMixin, { ClientType } from '~/mixins/AgreementsMixin'
  import { BindingHelpers } from 'vuex-class/lib/bindings'
  import { namespace } from 'vuex-class'

  type ItemAgreements = Account.App.Responses.Agreement | Account.App.Responses.InvoiceAgreement
  const account: BindingHelpers = namespace('account')

  // TODO: This component logic looks too complex and should be refactored
  @Component({
    components: {
      OneIconLoader: () => import('~/components/molecules/icons/OneIconLoader.vue'),
    },
  })
  export default class OneAgreementsList extends mixins(AgreementsMixin) {
    @account.State currentUser: any;

    @Prop({
      type: Boolean,
      default: false,
    })
    notSaveData!: Boolean

    @Prop({
      type: Boolean,
      default: false,
    })
    isCartView!: Boolean

    @Prop({
      type: Boolean,
      default: false,
    })
    onlyUnselected!: Boolean

    @Prop({
      type: String,
      required: false,
      default: null,
    })
    clientType!: ClientType | null

    @Prop({
      type: String,
      default: '',
    })
    setInvoiceEmail!: string

    @Prop({
      type: String,
      default: '',
    })
    context!: string

    @Prop({
      type: Boolean,
      default: false,
    })
    withoutToken!: boolean

    mountedAgreements: Array<string> = []
    innerAgreements: Array<Account.App.Responses.Agreement> = []
    requiredAgreementsAccepted: boolean = false
    invoiceEmailAgreement: string = ''
    currentClientType: ClientType = 'INDIVIDUAL'

    validateAgreements() {
      this.$validator.validate()
    }

    // Specific case: https://jira.univio.com/browse/UNITYONE-15207
    isInvoiceAgreementRequired(item: ItemAgreements) {
      const invoiceItem = item as Partial<Account.App.Responses.InvoiceAgreement>
      return invoiceItem.isRequired && !invoiceItem.isEditable
    }

    contentIsNotEmpty(item: ItemAgreements): boolean {
      return !!item.content
    }

    disableForContext(item: ItemAgreements): boolean {
      if (!this.context) {
        return false
      }
      if (this.isInvoiceEmailAgreement(item)) {
        if (this.context === 'ACCOUNT') {
          return item.isRequired ? item.isAccepted : false
        }
        if (this.context === 'CART') {
          return item.isRequired ? item.isAccepted : false
        }
      }
      return false
    }

    onlyUnselectedAgreements(item: ItemAgreements): boolean {
      return !this.onlyUnselected || (this.isRequired(item) || this.isMountedAgreement(item) || !(item && item.isAccepted))
    }

    isMountedAgreement(item: ItemAgreements): boolean {
      return this.mountedAgreements.includes('id' in item ? item.id : 'electronicInvoices')
    }

    checkboxDisabled(item: ItemAgreements): boolean {
      return this.isInvoiceEmailAgreement(item) && (!this.invoiceEmailAgreement || !!this.validInvoiceEmailInput)
    }

    findElectronicInvoiceAgreementAcceptance(): boolean {
      /**
       * There can be only a single (1) 'ELECTRONIC_INVOICES' agreement.
       */
      const invoiceAgreementId = Object.keys(this.agreements)
        .find((key: string) =>
          this.agreements[key].type === 'ELECTRONIC_INVOICES')
      return invoiceAgreementId ? this.agreements[invoiceAgreementId].isAccepted : false
    }

    get validInvoiceEmailInput(): string {
      return this.errors && this.errors.first('invoiceEmail')
    }

    async stateChange(item: ItemAgreements, isAccepted?: boolean) {
      const modItem = cloneDeep(item)
      if (this.isInvoiceEmailAgreement(modItem)) {
        if (!this.$isFieldValid('invoiceEmail', true)) {
          return
        }
        /**
         * TODO electronicInvoices should not go through same pipeline with agreements
         * API treats electronicInvoices as a separate entity and probably so should frontend.
         * (OR backend should merge it with 'regular' agreements)
         * ItemAgreements interface should be split up to Agreement & InvoiceAgreement and validation/submitting flow needs an update.
         *
         * 'isAccepted' logic is spread between different components, AgreementMixin and oneCore.
         * It seems to work backwards. Select input uses {agreement.isAccepted} as model and updates it (correctly?).
         * Then we reverse the boolean, only to reverse it once again in oneCore.
         *
         * This is best to improve after we have test coverage over registration.
         */
        modItem.email = this.invoiceEmailAgreement
        if (!this.checkboxDisabled(modItem)) {
          modItem.isAccepted = (typeof isAccepted !== 'undefined') ? isAccepted : !modItem.isAccepted
        } else {
          modItem.isAccepted = this.isInvoiceAgreementRequired(modItem) ? true : this.findElectronicInvoiceAgreementAcceptance()
        }
      }

      await this.updateLocalAgreements(modItem)
      if (!this.notSaveData) {
        await this.updateServerAgreements(modItem, this.withoutToken)
      }

      // @ts-ignore
      if (item?.type === 'ELECTRONIC_INVOICES') {
        // sync different electronic invoices structures
        await this.updateLocalAgreements({
          ...this.agreements.electronicInvoices,
          isAccepted: this.findElectronicInvoiceAgreementAcceptance(),
        })
      }

      this.emitStateChange()
    }

    emitStateChange() {
      this.$emit('state-change', {
        electronicInvoices: this.agreements.electronicInvoices,
        selectedAgreementsIds: this.selectedAgreementsIds,
        isRequiredAgreementMarked: this.isValidAgreements,
      })
    }

    setSelectedAgreements() {
      this.innerAgreements = []
      Object.keys(this.agreements).forEach((key: string) => {
        this.innerAgreements.push(this.agreements[key])
        if (this.isInvoiceEmailAgreement(this.agreements[key])) {
          this.invoiceEmailAgreement = this.agreements[key].email
        }
      })
      this.checkIfRequiredAgreementsAccepted()
    }

    checkIfRequiredAgreementsAccepted() {
      this.requiredAgreementsAccepted = this.innerAgreements.filter(x => this.isRequired(x) && !x.isAccepted).length < 1
      this.$emit('on-agreements-accepted', this.requiredAgreementsAccepted)
    }

    setListMountedAgreements() {
      this.mountedAgreements = Object.keys(this.agreements).filter(el => !this.agreements[el].isAccepted)
    }

    setCurrentClientType() {
      if (!this.clientType) {
        this.currentClientType = this.isCompanyCustomerType ? 'ORGANIZATION' : 'INDIVIDUAL'
      } else {
        this.currentClientType = this.clientType
      }
    }

    setAgreementsInputsTestIds() {
      document.querySelectorAll('.agreement-checkbox')?.forEach((el, index) => {
        el.querySelector('.custom-control-input')?.setAttribute('data-testid', `core:agreements:agreement-${index}-element:checkbox-input`)
      })
    }

    isChecked(item: ItemAgreements): boolean {
      return item.isAccepted
    }

    async mounted() {
      try {
        this.setCurrentClientType()
        // TODO: What to fetch when user is anonymous and no clientType passed...? UNITYONE-7001
        if (this.clientType) {
          await this.fetchRegistrationAgreements(this.currentClientType)
        } else if (this.$auth.isAuthenticated) {
          await this.fetchUserAgreements()
        }
      } catch (e) {
        this.$logger.warn(e)
      }
      this.setListMountedAgreements()
      this.emitStateChange()
      this.setAgreementsInputsTestIds()
    }

    @Watch('clientType')
    onClientTypeChanged() {
      this.setCurrentClientType()
      this.fetchRegistrationAgreements(this.currentClientType)
    }

    @Watch('setInvoiceEmail')
    setInvoiceEmailAgreement() {
      this.invoiceEmailAgreement = this.setInvoiceEmail
      const electronicInvoicesAgreement = this.innerAgreements
        // @ts-ignore
        .find(agreement => agreement?.type === 'ELECTRONIC_INVOICES')
      this.stateChange(this.agreements.electronicInvoices, !!electronicInvoicesAgreement?.isAccepted)
    }

    @Watch('agreements', { deep: true, immediate: true })
    onStateAgreementsChanged() {
      this.setSelectedAgreements()
    }
  }
